module.exports = __webpack_public_path__ + "static/media/body-bg-top.9815604f.jpg";